import Button from "react-bootstrap/Button";

export const ButtonFormSubmit = ({
  formOnSubmit,
  buttonText,
  disableButton = false,
  className = "w-100 h-100",
}) => {
  return (
    <Button
      className={className}
      variant="outline-offblack"
      type="submit"
      onClick={formOnSubmit}
      disabled={disableButton}
    >
      {buttonText}
    </Button>
  );
};
